import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from '@app/store';

export interface ILoadingState {
  isLoading: boolean;
  isInitializing: boolean;
  isInitialized: boolean;
  isNoPersonIdResolved: boolean;
  isNoPersonFound: boolean;
  isNoCompanyFound: boolean;
  // The API refused the agent (403): their account lacks the support agent role
  isAccessDenied: boolean;
  isAuthFailed: boolean;
  isZafClientFailed: boolean;
}

const initialState: ILoadingState = {
  isInitializing: true,
  isInitialized: false,
  isLoading: false,
  isNoPersonIdResolved: false,
  isNoPersonFound: false,
  isNoCompanyFound: false,
  isAccessDenied: false,
  isAuthFailed: false,
  isZafClientFailed: false,
};

export const selectIsLoading = (state: IRootState) => state.loading.isLoading;

export const selectIsInitializing = (state: IRootState) =>
  state.loading.isInitializing;

export const selectIsNoUserIdResolved = (state: IRootState) =>
  state.loading.isNoPersonIdResolved;

export const selectIsNoUserFound = (state: IRootState) =>
  state.loading.isNoPersonFound;

export const selectIsNoCompanyFound = (state: IRootState) =>
  state.loading.isNoCompanyFound;

export const selectIsAccessDenied = (state: IRootState) =>
  state.loading.isAccessDenied;

export const selectIsAuthFailed = (state: IRootState) =>
  state.loading.isAuthFailed;

export const selectIsZafClientFailed = (state: IRootState) =>
  state.loading.isZafClientFailed;

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsInitializing: (state, action: PayloadAction<boolean>) => {
      state.isInitializing = action.payload;
    },
    setIsInitialized: (state, action: PayloadAction<boolean>) => {
      state.isInitialized = action.payload;
    },
    setIsNoPersonResolved: (state, action: PayloadAction<boolean>) => {
      state.isNoPersonIdResolved = action.payload;
    },
    setIsNoPersonFound: (state, action: PayloadAction<boolean>) => {
      state.isNoPersonFound = action.payload;
    },
    setIsNoCompanyFound: (state, action: PayloadAction<boolean>) => {
      state.isNoCompanyFound = action.payload;
    },
    setIsAccessDenied: (state, action: PayloadAction<boolean>) => {
      state.isAccessDenied = action.payload;
    },
    setIsAuthFailed: (state, action: PayloadAction<boolean>) => {
      state.isAuthFailed = action.payload;
    },
    setIsZafClientFailed: (state, action: PayloadAction<boolean>) => {
      state.isZafClientFailed = action.payload;
    },
  },
});

export const {
  setIsInitializing,
  setIsInitialized,
  setIsLoading,
  setIsNoPersonResolved,
  setIsNoCompanyFound,
  setIsAccessDenied,
  setIsAuthFailed,
  setIsZafClientFailed,
} = loadingSlice.actions;

export default loadingSlice.reducer;
